import { ProgramEnum, ProgramWeekEnum } from '../../models/programs';
import {
    CHANGE_FEEDBACK_FIELD,
    FeedbackAction,
    FETCH_PROGRAM_FEEDBACK_SUCCEEDED,
    FETCH_WEEK_FEEDBACK_SUCCEEDED,
} from '../actions/feedbackActions';
import { FeedbackState, WeeksAndProgramFeedback } from '../models/feedback';
import { feedbackDefaultState } from '../models/feedbackData';

const defaultState: FeedbackState = feedbackDefaultState;

export const feedbacks = (state: FeedbackState = defaultState, action: FeedbackAction) => {
    const getProgramFeedbacks = (programId: ProgramEnum): WeeksAndProgramFeedback | undefined =>
        state.programsFeedback && state.programsFeedback[programId];

    switch (action.type) {
        case FETCH_WEEK_FEEDBACK_SUCCEEDED: {
            const { programId, weekId, feedback } = action.payload;

            if (
                !Object.values(ProgramEnum).includes(programId) ||
                !Object.values(ProgramWeekEnum).includes(weekId)
            ) {
                return state;
            }

            const programFeedbacks = getProgramFeedbacks(programId);

            const weeksFeedbacks = programFeedbacks && programFeedbacks.weeksFeedbacks;

            return {
                ...state,
                programsFeedback: {
                    ...state.programsFeedback,
                    [programId]: {
                        ...programFeedbacks,
                        weeksFeedbacks: weeksFeedbacks
                            ? {
                                  ...weeksFeedbacks,
                                  [weekId]: feedback,
                              }
                            : {
                                  [weekId]: feedback,
                              },
                    },
                },
            };
        }
        case FETCH_PROGRAM_FEEDBACK_SUCCEEDED: {
            const { programId, feedback } = action.payload;

            if (!Object.values(ProgramEnum).includes(programId)) {
                return state;
            }

            const programFeedbacks = getProgramFeedbacks(programId);

            return {
                ...state,
                programsFeedback: {
                    ...state.programsFeedback,
                    [programId]: {
                        ...programFeedbacks,
                        programFeedback: feedback,
                    },
                },
            };
        }
        case CHANGE_FEEDBACK_FIELD: {
            const { programId, weekId, field, value } = action.payload;

            if (
                !Object.values(ProgramEnum).includes(programId) ||
                (weekId && !Object.values(ProgramWeekEnum).includes(weekId))
            ) {
                return state;
            }

            const programFeedbacks = getProgramFeedbacks(programId) || {};

            if (!weekId) {
                const programFeedback = programFeedbacks && programFeedbacks.programFeedback;

                const updatedProgramFeedback = programFeedback
                    ? { ...programFeedback, [field]: value }
                    : { [field]: value };

                return {
                    ...state,
                    programsFeedback: {
                        ...state.programsFeedback,
                        [programId]: {
                            ...programFeedbacks,
                            programFeedback: updatedProgramFeedback,
                        },
                    },
                };
            }

            const weeksFeedbacks = programFeedbacks && programFeedbacks.weeksFeedbacks;

            const weekFeedback = weeksFeedbacks && weeksFeedbacks[weekId];

            const updatedWeekFeedback = weekFeedback
                ? { ...weekFeedback, [field]: value }
                : { [field]: value };

            return {
                ...state,
                programsFeedback: {
                    ...state.programsFeedback,
                    [programId]: {
                        ...programFeedbacks,
                        weeksFeedbacks: weeksFeedbacks
                            ? {
                                  ...weeksFeedbacks,
                                  [weekId]: updatedWeekFeedback,
                              }
                            : {
                                  [weekId]: updatedWeekFeedback,
                              },
                    },
                },
            };
        }

        default:
            return state;
    }
};
